<template>
<div class="chapter">
<div class="inner_page">
<a id="page_1"></a>
<p class="half">BRITAIN’S SECOND-HAND</p>
<p class="half1"><span class="bold">TRAMS</span></p>
<div class="boxh">
<p class="aut">A<span class="small">N</span> H<span class="small">ISTORIC</span> O<span class="small">VERVIEW</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Halftitle.vue?6fba44b1